import type { MachineSetupRepository } from '../data/machine-setup-repository';

export class GetActorsForOperatorUseCase {
  constructor(private readonly repository: MachineSetupRepository) {}

  async execute(operatorId: number): Promise<Array<{ actorId: number; name: string; parentActorId?: number }>> {
    return this.repository.getActorsForOperator(operatorId);
  }
}
